





































































import Vue from 'vue';
import { AxiosError } from 'axios';
import { mapActions } from 'vuex';

import { Quote, QuoteState } from '@/models/quote';
import { ISystemError } from '@/models/error';

import { ALForm } from '@/common/component.types';
import { setErrorFromAxiosError } from '@/utils/helpers';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'QuoteOrderFormDialog',

  components: { ConfirmationDialog },

  data: () => ({
    isFormValid: false,
    dialog: false,
    loading: false,

    order: '',
    customer: '',

    quoteNumber: null as null | number,

    rules: [
      (v: string) => !!v || 'Field is required',
      (v: string) => v.length < 16 || 'Field cannot be more than 16 characters'
    ],

    error: null as null | ISystemError
  }),

  methods: {
    ...mapActions({
      createOrderFromQuote: 'quote/createOrderFromQuote'
    }),

    clearAllErrors(): void {
      this.error = null;
    },

    open(quote: Quote) {
      this.quoteNumber = quote.number!;
      this.customer = quote.customer!.identifier!;
      this.clearAllErrors();
      this.resetFormValidation;

      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    createOrder() {
      this.clearAllErrors();
      if (this.validateForm()) {
        this.loading = true;

        this.createOrderFromQuote({
          id: this.quoteNumber,
          order: this.order,
          customer: this.customer
        })
          .then((state: QuoteState) => {
            this.close();
            this.$emit('quote:order-created', state);
          })
          .catch(err => {
            this.error = setErrorFromAxiosError(err as AxiosError);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
});
